(function($) {

    $(document).ready(function() {
        if ((".accordian-with-img").length > 0) {
            $('.accordian-with-img .link-with-white').on('mouseenter mouseleave', function(e) {
                var curClass = $(this).attr("id");
                if (e.type == "mouseenter") {
                    $("#" + curClass).addClass("active");
                } else {
                    $("#" + curClass).removeClass("active");
                }
            });
        }

        if ((".col-two-block.bg-mahogany").length > 0) {
            $("body").addClass("height");
        }

        $('.fellow-carousel.bg-black').addClass('height');

    });

    $(window).on('load', function() {
        setTimeout(function() {
            if ($('div[role="contentinfo"]').length > 0) {
                var count = $('div[role="contentinfo"]').text().length;
                if (count === 95) {
                    $('html, body').animate({
                        scrollTop: $(".col-two-block").offset().top - $("header").outerHeight()
                    }, '1500');
                }
            }
        }, 600);
        setTimeout(function() {
            $(".fellow-carousel.bg-black").removeClass('height');
            $("body").removeClass("height");
        }, 700);
    });


})(jQuery);